module.exports = __webpack_public_path__ + "img/what-is-music-licensing-admin.7f9b852a.jpg";